module.exports = parseInt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/math/to-integer.js
// module id = 102
// module chunks = 0